import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';

import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { FormSubmittedComponent } from './form-submitted/form-submitted.component';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
  },

  {
    path: 'portfolio-management',
    loadChildren: () =>
      import('./portfolio-manager-module/portfolio-manager-module.module').then(
        (m) => m.PortfolioManagerModuleModule
      ),
  },
  {
    path: 'services',
    loadChildren: () =>
      import('./services-modules/services.module').then(
        (m) => m.ServicesModule
      ),
  },

  {
    path: 'consulting',
    loadChildren: () =>
      import('./consulting-service/consulting-service.module').then(
        (m) => m.ConsultingServiceModule
      ),
  },
  {
    path: 'employment-form',
    loadChildren: () =>
      import(
        './portfolio-manager-module/job-opportunities-module/employment-form/employment-form.module'
      ).then((m) => m.EmploymentFormModule),
  },
  {
    path: 'request-ack',
    component: FormSubmittedComponent,
  },
  {
    path: 'disclaimer',
    component: DisclaimerComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/home',
  },
  {
    path: '**',
    redirectTo: '/home',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
